<template>
    <Modal
         ref="addUserManagementModal"
        :size="'modal-xl'"
        :title="modalTitle"
        :saveNeeded="false"
        :dismissNeeded="false"
        :footerNeeded="false"
        @close="close"
    >
        <div class="row">
            <div class="col-md-12">
                <form-wizard
                    title=""
                    subtitle=""
                    stepSize="md"
                    color="#3a3f51"
                    errorColor="none"
                    ref="addUserModal"
                    @on-complete="checkIfRightIsSelected()"
                    @on-validate="createUserDetails(selectedUser.user)"   
                >
                    <tab-content 
                        title="User Details"
                        icon="fa fa-user"
                        :before-change="()=>validateStep('user-details')"
                    >
                    <form data-vv-scope="user-details">
                        <hr>
                        <div class="row">
                        <div class="col-md-6">
                            <div class="form-group" :class="{'has-error': errors.has('user-details.Email')}">
                                <label>Email</label>
                                <input type="email" class="form-control" v-model="selectedUser.user.emailAddress" name="Email" v-validate="'required'" :class="{'has-error': errors.has('user-details.Email')}" placeholder="Enter an Email Address">
                                <span class="has-error" v-if="errors.has('user-details.Email')">{{ errors.first('user-details.Email') }}</span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group" :class="{'has-error': errors.has('password')}">
                                <label>Password</label>
                                <MaskedPasswordInput 
                                    :password="password"
                                    :userCanEdit="true"
                                    @changePassword="changePassword"
                                />
                                <span class="has-error" v-if="errors.has('password')">{{ errors.first('password') }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="isStaffUserType">
                        <div class="col-md-6">
                            <div class="form-group" :class="{'has-error': errors.has('user-details.Firstnames')}">
                                <label>Firstnames</label>
                                <input type="text" class="form-control" v-model="selectedUser.user.firstNames" name="Firstnames" v-validate="'required'" :class="{'has-error': errors.has('user-details.Firstnames')}" placeholder="Enter a Firstname(s)">
                                <span class="has-error" v-if="errors.has('user-details.Firstnames')">{{ errors.first('user-details.Firstnames') }}</span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group" :class="{'has-error': errors.has('user-details.Lastname')}">
                                <label>Lastname</label>
                                <input type="text" class="form-control" v-model="selectedUser.user.lastName" name="Lastname" v-validate="'required'" :class="{'has-error': errors.has('user-details.Lastname')}" placeholder="Enter a Lastname">
                                <span class="has-error" v-if="errors.has('user-details.Lastname')">{{ errors.first('user-details.Lastname') }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="isStaffUserType">
                        <div class="col-md-6">
                            <div class="form-group" :class="{'has-error': errors.has('user-details.Labour Rate')}">
                                <label>Labour Rate</label>
                                <v-select
                                    ref="labourRateOptions"
                                    class="mb-2"
                                    :options="labourRates"
                                    placeholder="Select Labour rate"
                                    v-model="selectedUser.user.labourRate"
                                    name="Labour Rate" 
                                    v-validate="'required'"
                                    :class="{'has-error': errors.has('user-details.Labour Rate')}"
                                    clearable
                                >
                                </v-select>
                                <span class="has-error" v-if="errors.has('user-details.Labour Rate')">{{ errors.first('user-details.Labour Rate') }}</span>
                            </div>
                        </div>
                    </div>
                    <hr>
                    </form>
                    </tab-content>
                    <tab-content 
                        title="Access Rights Management"
                        icon="fa fa-key"
                    >
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <h4>User Access Rights</h4>
                                    <div class="form-group">
                                        <label>Assign Rights</label>
                                        <div class="row" v-if="showRightMessage === true">
                                            <div class="col-md-12">
                                                <p class="badge bg-danger" style="font-size: .95em; padding: 8px 16px"><i class="fa fa-warning mr-2"></i><strong>{{ rightMessage }}</strong></p>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-10" :class="{ 'col-md-12' :  rightObj === ''}">
                                                <v-select
                                                    ref="rightsOptions"
                                                    :options="availableUserRights"
                                                    v-model="rightObj"
                                                    label="description"
                                                    v-if="availableUserRights.length > 0"
                                                    placeholder="Assign right"
                                                >
                                                </v-select>
                                            </div>
                                            <div class="col-md-2" v-if="availableUserRights.length > 0 && rightObj != ''">
                                                <button class="btn btn-success float-right" @click="assignRightToUser(rightObj)">Add Right</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group" style="max-height: 250px; overflow-y: scroll">
                                        <ul class="list-group" v-if="selectedUser.rights.length > 0">
                                            <li class="list-group-item d-flex justify-content-between align-items-center" v-for="(right, name) in selectedUser.rights" :key="name">
                                                    <span><i class="fa fa-user-plus mr-2"></i>{{ right.description }}</span> 
                                                <div class="d-flex ustify-content-end">
                                                    <button class="btn btn-primary" @click="unassignUserRight(right)"><i class="fa fa-trash"></i></button>
                                                </div>
                                            </li>
                                        </ul>
                                        <ul class="list-group" v-else-if="availableUserRights.length > 0 && selectedUser.rights.length <= 0">
                                            <li class="list-group-item">
                                                <span><i class="fa fa-user-plus mr-2"></i>Assign rights to user</span>
                                            </li>
                                        </ul>
                                        <ul class="list-group" v-else>
                                            <li class="list-group-item">
                                                <span><i class="fa fa-user-times mr-2"></i>No rights available</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </tab-content>
                </form-wizard>
            </div>
        </div>
    </Modal>
</template>

<script>
import Modal from "@/components/GeneralComponents/Modal";
import MaskedPasswordInput from "@/components/GeneralComponents/InputControls/MaskedPasswordInput";
import {FormWizard, TabContent} from 'vue-form-wizard'
import "vue-form-wizard/dist/vue-form-wizard.min.css";

export default {
    components: {
        Modal,
        MaskedPasswordInput,
        FormWizard,
        TabContent
    },
    props: {
        modalTitle: {
            type: String,
            required: true,
        },
        selectedUserType: {
            type: String,
            required: true,
        },
        selectedUser: {
            type: Object,
            required: true,
        },
        availableUserRights: {
            type: Array,
            required: true,
        },
        labourRates: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            rightObj: '',
            addRights: [],
            rightMessage: 'Assign right in dropdown in order to finish',
            showRightMessage: false,
            password: '',
        }
    },
    computed: {
        isStaffUserType() {
            return this.selectedUserType.toLowerCase() === 'staff';
        }
    },
    methods: {
        open: function() {
            this.$refs.addUserManagementModal.open();

            this.$http.get(this.$config.aimsAPI + "password/generate/8").then(
                (response) => {
                    this.password = response.bodyText;                       
                },
                (error) => {
                    console.error(error);
                    this.showError("Error Generating Password", error);
                }
            );
        },
        changePassword: function(data) {
            if (data) {
                this.selectedUser.user.password = data;
            }
        },
        validateStep: function(stepName) {
            return this.$validator.validateAll(stepName).then(result => {  
                if (result) {
                    return true;
                } else {
                    return false;
                }
            });
        },
        checkIfRightIsSelected: function() {
            if (Object.keys(this.rightObj).length === 3) {                
                this.showRightMessage = true
            } else {
                this.closeModal();
            } 
        },
        createUserDetails: function(selectedUser) {           
            if (this.errors.items.length <= 0 && !selectedUser.staffUserNumber) {
                 this.$emit('createUser', selectedUser);
            }
        },
        assignRightToUser: function(rightObj) {
            this.showRightMessage = false
            this.$emit('assignRightToUser', rightObj);   
            this.$refs.rightsOptions._data.selectedValue = null;   
            this.rightObj = "";              
        },
        unassignUserRight: function(rightObj) {
            this.$emit('removeAssignedUserRight', rightObj);
        },
        close() {   
            this.errors.clear()
        },
        closeModal: function() {
            this.errors.clear()
            if (this.availableUserRights.length > 0) {
                this.$refs.rightsOptions._data.selectedValue = null;
            }

            if (this.selectedUserType.toLowerCase() === 'staff') {
                this.$refs.labourRateOptions._data.selectedValue = null;
            }
            this.showSuccess(`${this.selectedUserType} user successfully created`);
            this.$refs.addUserManagementModal.close();
            this.$refs.addUserModal.reset();
        }
    },
}
</script>
<style scoped>
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input { 
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #37bc9b;
}

input:focus + .slider {
  box-shadow: 0 0 1px #37bc9b;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}
.slider.round {
  border-radius: 34px;
}
</style>
